import React, { useContext, useState, useEffect, useRef } from "react";
import { CountryContext } from "../context/CountryContext";
import { Link, useLocation } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";

const NAV_ITEMS = [
  { label: "Home", href: "/" },
  { label: "Solutions", href: "/services" },
  { label: "Case studies", href: "/caseStudies" },
  { label: "Who we are", href: "/AboutUs" },
  { label: "Trainings", href: "/LabServices" },
  { label: "Blog", href: "/blog" },
  { label: "Careers", href: "/careers" },
];

const Nav = () => {
  const { country, setCountry } = useContext(CountryContext);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [showScrollTop, setShowScrollTop] = useState(false);
  const location = useLocation();
  const headerRef = useRef(null);

  // Scroll-aware frosted shadow + scroll-to-top visibility
  useEffect(() => {
    const handleScroll = () => {
      if (!headerRef.current) return;
      headerRef.current.classList.toggle("nav-scrolled", window.scrollY > 20);
      setShowScrollTop(window.scrollY > 400);
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Close mobile menu on route change
  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location.pathname]);

  const isActive = (href) =>
    href === "/" ? location.pathname === "/" : location.pathname.startsWith(href);

  return (
    <>
    <header ref={headerRef} className="anav bg-white w-100">
      <div className="container-xxl px-4 py-3">
        <div className="d-flex align-items-center justify-content-between">

          <Link to="/" className="d-flex align-items-center" style={{ textDecoration: "none" }}>
            <img src="/ecl-logo.png" alt="ECL Logo" className="img-fluid" style={{ height: "48px" }} />
          </Link>

          {/* Desktop nav */}
          <nav className="d-none d-lg-flex align-items-center gap-4 nv">
            {NAV_ITEMS.map((item, i) => (
              <Link
                key={i}
                to={item.href}
                className={`text-decoration-none small fw-medium nav-link-item${isActive(item.href) ? " nav-link-active" : ""}`}
              >
                {item.label}
              </Link>
            ))}
          </nav>

          <div className="d-flex align-items-center gap-3">

            {/* Language Dropdown */}
            {/* <div className="dropdown">
                <button
                  className="btn btn-light dropdown-toggle small text-dark border-0"
                  type="button"
                  onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                >
                  <i className="bi bi-globe me-1" />
                  {country || "Ghana"}
                </button>
                {isDropdownOpen && (
                  <ul className="dropdown-menu show">
                    {["Ghana", "Liberia"].map((c) => (
                      <li key={c}>
                        <button
                          className="dropdown-item"
                          onClick={() => { setCountry(c); setIsDropdownOpen(false); }}
                        >
                          {c}
                        </button>
                      </li>
                    ))}
                  </ul>
                )}
              </div> */}

            <Link to="/contactUsPage" className="btn btn-dark p-2 px-3 small d-none d-lg-inline-flex">
              Contact Us
            </Link>

            {/* Hamburger — mobile only */}
            <button
              className="d-lg-none btn btn-light border-0 p-2"
              onClick={() => setIsMobileMenuOpen(prev => !prev)}
              aria-label="Toggle navigation menu"
              aria-expanded={isMobileMenuOpen}
            >
              <i className={`bi ${isMobileMenuOpen ? "bi-x-lg" : "bi-list"}`} style={{ fontSize: 22 }} />
            </button>
          </div>
        </div>

        {/* Mobile menu — always in DOM, animated via CSS max-height */}
        <nav className={`mobile-nav d-lg-none${isMobileMenuOpen ? " open" : ""}`}>
          <div className="border-top mt-3 pt-3 pb-2">
            <div className="d-flex flex-column gap-1">
              {NAV_ITEMS.map((item, i) => (
                <Link
                  key={i}
                  to={item.href}
                  className={`text-decoration-none py-2 px-1 fw-medium small nav-link-item${isActive(item.href) ? " nav-link-active" : ""}`}
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  {item.label}
                </Link>
              ))}
              <Link
                to="/contactUsPage"
                className="btn btn-dark mt-2"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                Contact Us
              </Link>
            </div>
          </div>
        </nav>

      </div>
    </header>

    {/* Scroll-to-top button */}
    <button
      className={`scroll-to-top${showScrollTop ? " visible" : ""}`}
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      aria-label="Scroll to top"
    >
      <i className="bi bi-chevron-up" style={{ fontSize: 18 }} />
    </button>
    </>
  );
};

export default Nav;
